import { StyleSheet } from 'react-native';

import {
    Color,
    FontFamily,
    FontSize,
    Padding,
} from '@/styles/GlobalStyles';

export const styles = StyleSheet.create({
    container: {
        marginBottom: 16,
    },
    label: {
        color: Color.gray[300],
        fontFamily: FontFamily.regular,
        fontSize: FontSize.sm,
        marginBottom: 8,
    },
    scrollContent: {
        gap: 8,
    },
    chip: {
        paddingHorizontal: 12,
        paddingVertical: 6,
        borderRadius: 16,
        backgroundColor: Color.gray[50],
        borderWidth: 1,
        borderColor: Color.gray[100],
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4,
    },
    activeChip: {
        backgroundColor: Color.primary[300],
        borderColor: Color.primary[300],
    },
    chipText: {
        color: Color.gray[400],
        fontFamily: FontFamily.medium,
        fontSize: FontSize.xs,
    },
    activeChipText: {
        color: Color.gray.white,
    },
});
